



















import IconBase from "@/common/components/atoms/IconBase.vue";

import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    IconBase
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class A01PointWithIconPanel extends Vue {
  @Prop({ type: Number, required: true }) point!: number;
}
